import { apiRequest } from "./apiClient";

export async function uploadMedia(file) {
    if (!file) throw new Error("Aucun fichier selectionne");

    const formData = new FormData();
    formData.append("file", file);

    return apiRequest("/media/upload", {
        method: "POST",
        body: formData,
    });
}
